import routes from 'src/routes'
import proceedings from '../../images/gallerium/onDemand/proceedings.png'
import programmeBook from '../../images/gallerium/onDemand/programme-book.png'
import agenda from '../../images/gallerium/onDemand/agenda.png'
import platform from '../../images/gallerium/onDemand/platform.png'
import kenji from '../../images/gallerium/onDemand/bioThumbnail/kenji-kuno.png'
import bree from '../../images/gallerium/onDemand/bioThumbnail/bree.png'
import breeBlue from '../../images/gallerium/onDemand/handoutThumbnail/bree-blue.png'
import ailing from '../../images/gallerium/onDemand/bioThumbnail/ailing.png'
import ailingBlue from '../../images/gallerium/onDemand/handoutThumbnail/ailing-blue.png'
import kerry from '../../images/gallerium/onDemand/bioThumbnail/kerry.png'
import kerryBlue from '../../images/gallerium/onDemand/handoutThumbnail/kerry-blue.png'
import marilyn from '../../images/gallerium/onDemand/bioThumbnail/marilyn.png'
import marilynBlue from '../../images/gallerium/onDemand/handoutThumbnail/marilyn-blue.png'
import min from '../../images/gallerium/onDemand/bioThumbnail/min.png'
import minBlue from '../../images/gallerium/onDemand/handoutThumbnail/min-blue.png'
import zhariff from '../../images/gallerium/onDemand/bioThumbnail/zhariff.png'
import zhariffBlue from '../../images/gallerium/onDemand/handoutThumbnail/zhariff-blue.png'
import salmah from '../../images/gallerium/onDemand/bioThumbnail/salmah.png'
import salmahBlue from '../../images/gallerium/onDemand/handoutThumbnail/salmah-blue.png'
import mariam from '../../images/gallerium/onDemand/bioThumbnail/mariam.png'
import weningsih from '../../images/gallerium/onDemand/bioThumbnail/weningsih.png'
import weningsihBlue from '../../images/gallerium/onDemand/handoutThumbnail/weningsih-blue.png'

import nisai from '../../images/gallerium/onDemand/partners/nisai.png'
import nisaiIntro from '../../images/gallerium/onDemand/partners/nisai-intro.png'
import icevi from '../../images/gallerium/onDemand/partners/icevi.png'
import yobm from '../../images/gallerium/onDemand/partners/yobm.png'

import nisaiBooth from '../../images/gallerium/onDemand/booth/nisai.png'
import senBooth from '../../images/gallerium/onDemand/booth/sen.png'
import secretariatBooth from '../../images/gallerium/onDemand/booth/secretariat.png'
import geniusBooth from '../../images/gallerium/onDemand/booth/genius.png'
import moeBooth from '../../images/gallerium/onDemand/booth/moe.png'
import ncbmBooth from '../../images/gallerium/onDemand/booth/ncbm.png'
import mfdBooth from '../../images/gallerium/onDemand/booth/mfd.png'
import dyslexiaBooth from '../../images/gallerium/onDemand/booth/dyslexia.png'
import orkidsBooth from '../../images/gallerium/onDemand/booth/orkids.png'
import pestecBooth from '../../images/gallerium/onDemand/booth/pestec.png'

import brochure from '../../images/gallerium/onDemand/additional/brochure.png'
import fb from '../../images/gallerium/onDemand/additional/fb.png'
import web from '../../images/gallerium/onDemand/additional/web.png'
import youtube from '../../images/gallerium/onDemand/additional/youtube.png'
import q1 from '../../images/gallerium/onDemand/additional/q1.png'
import q2 from '../../images/gallerium/onDemand/additional/q2.png'
import video2017 from '../../images/gallerium/onDemand/additional/video2017.png'
import video2019 from '../../images/gallerium/onDemand/additional/video2019.png'
import video2015 from '../../images/gallerium/onDemand/additional/video2015.png'

import { onDemandVideosType } from './videos'

const kenjiBio = require('../../images/gallerium/onDemand/bio/kenji-bio.pdf')
const breeBio = require('../../images/gallerium/onDemand/bio/bree-bio.pdf')
const breeHandout = require('../../images/gallerium/onDemand/handout/bree-handout.pdf')
const ailingBio = require('../../images/gallerium/onDemand/bio/ailing-bio.pdf')
const kerryBio = require('../../images/gallerium/onDemand/bio/kerry-bio.pdf')
const kerryHandout = require('../../images/gallerium/onDemand/handout/kerry-handout.pdf')
const marilynBio = require('../../images/gallerium/onDemand/bio/marilyn-bio.pdf')
const marilynHandout = require('../../images/gallerium/onDemand/handout/marilyn-handout.pdf')
const minBio = require('../../images/gallerium/onDemand/bio/min-bio.pdf')
const minHandout = require('../../images/gallerium/onDemand/handout/min-handout.pdf')
const zhariffBio = require('../../images/gallerium/onDemand/bio/zhariff-bio.pdf')
const zhariffHandout = require('../../images/gallerium/onDemand/handout/zhariff-handout.pdf')
const salmahBio = require('../../images/gallerium/onDemand/bio/salmah-bio.pdf')
const salmahHandout = require('../../images/gallerium/onDemand/handout/salmah-handout.pdf')
const mariamBio = require('../../images/gallerium/onDemand/bio/mariam-bio.pdf')
const weningsihBio = require('../../images/gallerium/onDemand/bio/weningsih-bio.pdf')
const weningsihHandout = require('../../images/gallerium/onDemand/handout/weningsih-handout.pdf')

const nisaiProfile = require('../../images/gallerium/onDemand/profile/nisai.pdf')
const senProfile = require('../../images/gallerium/onDemand/profile/sen.pdf')
const secretariatProfile = require('../../images/gallerium/onDemand/profile/secretariat.pdf')
const geniusProfile = require('../../images/gallerium/onDemand/profile/genius.pdf')
const moeProfile = require('../../images/gallerium/onDemand/profile/moe.pdf')
const ncbmProfile = require('../../images/gallerium/onDemand/profile/ncbm.pdf')
const mfdProfile = require('../../images/gallerium/onDemand/profile/mfd.pdf')
const dyslexiaProfile = require('../../images/gallerium/onDemand/profile/dyslexia.pdf')
const orkidsProfile = require('../../images/gallerium/onDemand/profile/orkids.pdf')
const pestecProfile = require('../../images/gallerium/onDemand/profile/pestec.pdf')

const agendaPdf = require('../../images/gallerium/onDemand/agenda.pdf')
const nisaiPdf = require('../../images/gallerium/onDemand/partner/nisaiP.pdf')
const iceviPdf = require('../../images/gallerium/onDemand/partner/icevi.pdf')
const yobmPdf = require('../../images/gallerium/onDemand/partner/yobm.pdf')
export interface onDemandCategoryType {
  id: string
  thumbnail?: string
  destination?: string
  categoryName?: string
  type?: string
  videos?: Array<onDemandVideosType>
}

const onDemandCategories: Array<onDemandCategoryType> = [
  {
    id: 'group1-1',
    type: 'additional',
    thumbnail: proceedings,
    destination: 'https://publication.seameosen.org/proc2021/ ',
  },
  {
    id: 'group1-2',
    type: 'additional',
    thumbnail: programmeBook,
    destination: 'https://drive.google.com/drive/folders/1vZhFflhtB9BuXbDL1PJ2_3MX78g_O6RD?usp=sharing ',
  },
  {
    id: 'group1-3',
    type: 'pdf',
    thumbnail: agenda,
    destination: agendaPdf,
  },
  {
    id: 'group1-4',
    thumbnail: platform,
    type: 'video',
    destination: 'https://player.vimeo.com/video/608131148?h=9ff1d27a73&autoplay=1',
  },
  {
    id: 'group2-1',
    type: 'pdf',
    thumbnail: kenji,
    destination: kenjiBio,
  },
  {
    id: 'group2-2',
    type: 'pdf',
    thumbnail: bree,
    destination: breeBio,
  },
  {
    id: 'group2-3',
    type: 'pdf',
    thumbnail: breeBlue,
    destination: breeHandout,
  },
  {
    id: 'group2-4',
    type: 'pdf',
    thumbnail: ailing,
    destination: ailingBio,
  },
  // {
  //   id: 'group2-5',
  //   type: 'pdf',
  //   thumbnail: ailingBlue,
  //   destination: routes.onDemand,
  // },
  {
    id: 'group2-6',
    type: 'pdf',
    thumbnail: kerry,
    destination: kerryBio,
  },
  {
    id: 'group2-7',
    type: 'pdf',
    thumbnail: kerryBlue,
    destination: kerryHandout,
  },
  {
    id: 'group2-8',
    type: 'pdf',
    thumbnail: marilyn,
    destination: marilynBio,
  },
  {
    id: 'group2-9',
    type: 'pdf',
    thumbnail: marilynBlue,
    destination: marilynHandout,
  },
  {
    id: 'group2-10',
    type: 'pdf',
    thumbnail: min,
    destination: minBio,
  },
  {
    id: 'group2-11',
    type: 'pdf',
    thumbnail: minBlue,
    destination: minHandout,
  },
  {
    id: 'group2-12',
    type: 'pdf',
    thumbnail: zhariff,
    destination: zhariffBio,
  },
  {
    id: 'group2-13',
    type: 'pdf',
    thumbnail: zhariffBlue,
    destination: zhariffHandout,
  },
  {
    id: 'group2-14',
    type: 'pdf',
    thumbnail: salmah,
    destination: salmahBio,
  },
  {
    id: 'group2-15',
    type: 'pdf',
    thumbnail: salmahBlue,
    destination: salmahHandout,
  },
  {
    id: 'group2-16',
    type: 'pdf',
    thumbnail: mariam,
    destination: mariamBio,
  },
  {
    id: 'group2-17',
    type: 'pdf',
    thumbnail: weningsih,
    destination: weningsihBio,
  },
  {
    id: 'group2-18',
    type: 'pdf',
    thumbnail: weningsihBlue,
    destination: weningsihHandout,
  },
  {
    id: 'group3-1',
    type: 'pdf',
    thumbnail: nisai,
    destination: nisaiPdf,
  },
  {
    id: 'group3-2',
    type: 'video',
    thumbnail: nisaiIntro,
    destination: 'https://player.vimeo.com/video/605829666?h=89b62d41c9&autoplay=1',
  },
  {
    id: 'group3-4',
    type: 'pdf',
    thumbnail: icevi,
    destination: iceviPdf,
  },
  {
    id: 'group3-5',
    type: 'pdf',
    thumbnail: yobm,
    destination: yobmPdf,
  },
  {
    id: 'group4-1',
    type: 'pdf',
    thumbnail: nisaiBooth,
    destination: nisaiProfile,
  },
  {
    id: 'group4-2',
    type: 'pdf',
    thumbnail: senBooth,
    destination: senProfile,
  },
  {
    id: 'group4-3',
    type: 'pdf',
    thumbnail: secretariatBooth,
    destination: secretariatProfile,
  },
  {
    id: 'group4-4',
    type: 'pdf',
    thumbnail: geniusBooth,
    destination: geniusProfile,
  },
  {
    id: 'group4-5',
    type: 'pdf',
    thumbnail: moeBooth,
    destination: moeProfile,
  },
  {
    id: 'group4-6',
    type: 'pdf',
    thumbnail: ncbmBooth,
    destination: ncbmProfile,
  },
  {
    id: 'group4-7',
    type: 'pdf',
    thumbnail: mfdBooth,
    destination: mfdProfile,
  },
  {
    id: 'group4-8',
    type: 'pdf',
    thumbnail: dyslexiaBooth,
    destination: dyslexiaProfile,
  },
  {
    id: 'group4-9',
    type: 'pdf',
    thumbnail: orkidsBooth,
    destination: orkidsProfile,
  },
  {
    id: 'group4-10',
    type: 'pdf',
    thumbnail: pestecBooth,
    destination: pestecProfile,
  },
  {
    id: 'group5-1',
    type: 'additional',
    thumbnail: brochure,
    destination: 'https://library.seameosen.org/index.php?p=show_detail&id=247',
  },
  {
    id: 'group5-2',
    type: 'additional',
    thumbnail: fb,
    destination: 'https://facebook.seameosen.org',
  },
  {
    id: 'group5-3',
    type: 'additional',
    thumbnail: web,
    destination: 'https://seameosen.org',
  },
  {
    id: 'group5-3',
    type: 'additional',
    thumbnail: youtube,
    destination: 'https://youtube.seameosen.org',
  },
  {
    id: 'group5-4',
    type: 'additional',
    thumbnail: q1,
    destination: 'https://library.seameosen.org/index.php?p=show_detail&id=248',
  },
  {
    id: 'group5-5',
    type: 'additional',
    thumbnail: q2,
    destination: 'https://library.seameosen.org/index.php?p=show_detail&id=249',
  },
  {
    id: 'group5-6',
    type: 'video',
    thumbnail: video2017,
    destination: 'https://player.vimeo.com/video/603851688?autoplay=1',
  },
  {
    id: 'group5-7',
    type: 'video',
    thumbnail: video2019,
    destination: 'https://player.vimeo.com/video/603852103?autoplay=1',
  },
  {
    id: 'group5-8',
    type: 'video',
    thumbnail: video2015,
    destination: 'https://player.vimeo.com/video/603851387?autoplay=1',
  },
]

export { onDemandCategories }
